import React from "react";
import './IDDialog.sass'
import { WAITING } from "../../../variables";

function IDDIalogGuide({ status = WAITING }) {

  const guideWidth = 400;
  const guideHeight = Math.round(guideWidth / 1.6);
  return (
    <>
      <hr className="hr-animation" />
      <div
        className=" id-guide-overlay"
        style={{
          top: 0,
          left: 0,
          width: "100%",
          height: `calc(50% - ${guideHeight / 2}px)`,
        }}
      />
      <div
        className="id-guide-overlay"
        style={{
          top: `calc(50% + ${guideHeight / 2}px)`,
          left: 0,
          width: "100%",
          height: `calc(50% - ${guideHeight / 2}px)`,
        }}
      />
      <div
        className="id-guide-overlay"
        style={{
          top: `calc(50% - ${guideHeight / 2}px)`,
          left: 0,
          width: `calc(50% - ${guideWidth / 2}px)`,
          height: `${guideHeight}px`,
        }}
      />
      <div
        className="id-guide-overlay"
        style={{
          top: `calc(50% - ${guideHeight / 2}px)`,
          left: `calc(50% + ${guideWidth / 2}px)`,
          width: `calc(50% - ${guideWidth / 2}px)`,
          height: `${guideHeight}px`,
        }}
      />
      <div
        className={`id-guide-rect ${status}`}
        style={{
          width: guideWidth,
          height: guideHeight
        }}
      />
    </>
  );
}

export default IDDIalogGuide;